import styled from 'styled-components'
import { S_PopoverContainer } from '../../Popover'
import colors from '../../../_constants/colors'

export const S_FeeSummary = styled.div`
  border: ${colors.OUTLINE_GREY_BOX} 1px solid;
  border-radius: 3px;
  margin-top: 16px;
  padding: 15px;
  display: flex;
  flex-direction: column;

  .fee-summary {
    font-size: 14px;
    color: ${colors.DEFAULT_TEXT};
    margin-bottom: 15px;
  }

  .fee-name,
  .fee-type {
    margin-bottom: 5px;
  }

  .fee-summary-actions {
    margin-top: auto;
    margin-bottom: 0;
  }

  ${S_PopoverContainer} {
    margin-right: 8px;
    margin-bottom: 15px;
  }
`
export const S_Indicator = styled.div`
  margin-right: 8px;
  max-height: 16px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
`
